import { render, staticRenderFns } from "./EmpChange.vue?vue&type=template&id=4859bd9e"
import script from "./EmpChange.vue?vue&type=script&lang=js"
export * from "./EmpChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports